angular.module('unergie.main')
.filter('dealStatus', (BoFeaturesService) =>
    function (val) {
        switch (val) {
            case 'PRM_KO': return 'Pas de PRM ou PRM inéligible'
            case 'DRAFT': return 'Draft'
            case 'CLIENT_CHECKOUT': return 'Checkout client'
            case 'CONTRACT_OK': return 'À transmettre'
            case 'CONTRACT_PROCESSED': return 'Transmis Enedis'
            case 'CONTRACT_PROCESSED_LATE': return 'Retard Enedis'
            case 'WAITING_RETRACT': return 'Délai de retract.'
            case 'ENEDIS_ERROR': return 'Erreur Enedis'
            case 'DUPLICATE': return 'Duplicat'
            case 'WAITING_SWITCH_READINGS': return 'Attente client (Relève)'
            case 'CONTRACT_PROCESSING': return 'Attente client (RDV)'
            case 'DEAL_FINISHED_OK': return 'Contrat Actif'
            case 'UNREACHABLE': return 'Injoignable'
            case 'RETRACTED': return 'Contrat rétracté'
            case 'UNCLEAR': return 'Indéfini'
            case 'CANCELLED': return 'Annulé'
            default: return val
        }
    }
)
